import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

// Provisorische Erfolgsmeldung nach Place Order: ReleaseBasket navigiert mit
// `?placed=1` zurück nach /vts-order, dieser Banner erkennt das Flag, zeigt
// die Bestätigung und entfernt den Param wieder, damit ein Reload nicht
// erneut den Banner triggert.
export default function PlaceOrderSuccessBanner() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [show] = useState(() => searchParams.get('placed') === '1');

  useEffect(() => {
    if (show && searchParams.has('placed')) {
      const next = new URLSearchParams(searchParams);
      next.delete('placed');
      setSearchParams(next, { replace: true });
    }
  }, [show, searchParams, setSearchParams]);

  if (!show) return null;

  return (
    <Container className={'pt-4'}>
      <Row>
        <Col>
          <Alert variant="success" className="mb-0">
            Your order has been placed. A confirmation will follow by email.
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}
